import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyAvnow1RANKCJVqsj81lGkDDQF-W-6gvMQ",
//   authDomain: "smarthatch-login-system.firebaseapp.com",
//   projectId: "smarthatch-login-system",
//   storageBucket: "smarthatch-login-system.appspot.com",
//   messagingSenderId: "887102125995",
//   appId: "1:887102125995:web:ad2fda8c38d8f8ec65c4ee",
//   measurementId: "G-0K2H0VDDDH",
// };
const firebaseConfig = {
  apiKey: "AIzaSyDTPddMukfNdP-j4vCRlYRpPuaxk2ssHTQ",
  authDomain: "smarthatch-login.firebaseapp.com",
  projectId: "smarthatch-login",
  storageBucket: "smarthatch-login.firebasestorage.app",
  messagingSenderId: "20222500953",
  appId: "1:20222500953:web:2e49cc7879e054008f1148",
  measurementId: "G-5SLNZNNN88"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
